// Dados das atividades - hardcoded no frontend
export const activitiesData = [
  {
    id: "passeio-cultural",
    translations: {
      pt: {
        title: "Passeio Cultural em barco",
        description: "Um rio. Dois países. Uma história partilhada! Conheça a história inexplorada do primeiro ponto de encontro de Portugal e Espanha num passeio de barco a partir de Vila Real de Santo António.",
        short_description: "Um rio. Dois países. Uma história partilhada!"
      },
      en: {
        title: "Cultural Boat Tour",
        description: "One river. Two countries. A shared history! Discover the unexplored history of the first meeting point between Portugal and Spain.",
        short_description: "One river. Two countries. A shared history!"
      },
      es: {
        title: "Paseo Cultural en barco",
        description: "Un río. Dos países. ¡Una historia compartida! Conozca la historia inexplorada del primer punto de encuentro entre Portugal y España.",
        short_description: "Un río. Dos países. ¡Una historia compartida!"
      }
    },
    duration: "1 hora",
    image_url: "https://cdn.filestackcontent.com/WyA0RgODQbmADh2xD0oP/convert?cache=true&compress=true&quality=90&format=webp&rotate=exif&h=692&fit=max",
    booking_link: "https://fareharbor.com/embeds/book/nautitours_pt/items/709314/?full-items=yes&flow=1580578",
    active: true,
    order: 1
  },
  {
    id: "passeio-sunset",
    translations: {
      pt: {
        title: "Passeio Sunset em barco",
        description: "Hora dourada: experiência do pôr do sol no Guadiana! Não existe segredo: é a maneira perfeita de terminar um excelente dia.",
        short_description: "Hora dourada no Guadiana!"
      },
      en: {
        title: "Sunset Boat Tour",
        description: "Golden hour: Guadiana sunset experience! The perfect way to end an excellent day.",
        short_description: "Golden hour on the Guadiana!"
      },
      es: {
        title: "Paseo Sunset en barco",
        description: "Hora dorada: ¡experiencia de puesta de sol en el Guadiana! La manera perfecta de terminar un excelente día.",
        short_description: "Hora dorada en el Guadiana!"
      }
    },
    duration: "1 hora",
    image_url: "https://cdn.filestackcontent.com/yyDY8eVITj63uIqaXR47/convert?cache=true&compress=true&quality=90&format=webp&rotate=exif&h=1052&fit=max",
    booking_link: "https://fareharbor.com/embeds/book/nautitours_pt/items/709654/?full-items=yes&flow=1580578",
    active: true,
    order: 2
  },
  {
    id: "transfer-praia",
    translations: {
      pt: {
        title: "Transfer para a praia",
        description: "Travessia privada do rio até uma praia selvagem e intocada! Reserve já a sua experiência.",
        short_description: "Travessia para praia selvagem!"
      },
      en: {
        title: "Beach Transfer",
        description: "Private river crossing to a wild and untouched beach! Book your experience now.",
        short_description: "Crossing to wild beach!"
      },
      es: {
        title: "Transfer a la playa",
        description: "¡Cruce privado del río hasta una playa salvaje e intacta! Reserve ya su experiencia.",
        short_description: "¡Cruce a playa salvaje!"
      }
    },
    duration: "5 minutos",
    image_url: "https://cdn.filestackcontent.com/3qB08Sj1SdwCW34Mk3QN/convert?cache=true&compress=true&quality=90&format=webp&rotate=exif&w=920&fit=max",
    booking_link: "https://fareharbor.com/embeds/book/nautitours_pt/items/709659/?full-items=yes&flow=1580578",
    active: true,
    order: 3
  },
  {
    id: "mota-agua",
    translations: {
      pt: {
        title: "Mota de água",
        description: "Algarve Jet Ski Adventure: Guadiana River! Para quem adora a emoção da velocidade.",
        short_description: "Jet Ski Adventure no Guadiana!"
      },
      en: {
        title: "Jet Ski",
        description: "Algarve Jet Ski Adventure: Guadiana River! For those who love the thrill of speed.",
        short_description: "Jet Ski Adventure on Guadiana!"
      },
      es: {
        title: "Moto de agua",
        description: "Algarve Jet Ski Adventure: ¡Río Guadiana! Para quienes adoran la emoción de la velocidad.",
        short_description: "¡Jet Ski Adventure en Guadiana!"
      }
    },
    duration: "a partir de 15 minutos",
    image_url: "https://cdn.filestackcontent.com/O4kur4QTCyEPuFdoIwVT/convert?cache=true&compress=true&quality=90&format=webp&rotate=exif&h=692&fit=max",
    booking_link: "https://fareharbor.com/embeds/book/nautitours_pt/items/709667/?full-items=yes&flow=1580578",
    active: true,
    order: 4
  },
  {
    id: "aluguer-kayak",
    translations: {
      pt: {
        title: "Aluguer de Kayak",
        description: "Guadiana: Experiência de caiaque! Aventura em Kayak pelas margens do Guadiana.",
        short_description: "Experiência de caiaque!"
      },
      en: {
        title: "Kayak Rental",
        description: "Guadiana: Kayak Experience! Kayak adventure along the banks of the Guadiana.",
        short_description: "Kayak Experience!"
      },
      es: {
        title: "Alquiler de Kayak",
        description: "Guadiana: ¡Experiencia en kayak! Aventura en Kayak por las orillas del Guadiana.",
        short_description: "¡Experiencia en kayak!"
      }
    },
    duration: "1-2 Horas",
    image_url: "https://cdn.filestackcontent.com/YKur8GAxTj2d5XGvPtK5/convert?cache=true&compress=true&quality=90&format=webp&rotate=exif&w=920&fit=max",
    booking_link: "https://fareharbor.com/embeds/book/nautitours_pt/items/709682/?full-items=yes&flow=1580578",
    active: true,
    order: 5
  },
  {
    id: "aluguer-sup",
    translations: {
      pt: {
        title: "Aluguer de Stand Up Paddle",
        description: "Guadiana: Experiência de Stand Up Paddle! Passeio relaxante junto à margem Portuguesa.",
        short_description: "Experiência de SUP!"
      },
      en: {
        title: "Stand Up Paddle Rental",
        description: "Guadiana: Stand Up Paddle Experience! Relaxing tour along the Portuguese bank.",
        short_description: "SUP Experience!"
      },
      es: {
        title: "Alquiler de Stand Up Paddle",
        description: "Guadiana: ¡Experiencia de Stand Up Paddle! Paseo relajante junto a la orilla portuguesa.",
        short_description: "¡Experiencia de SUP!"
      }
    },
    duration: "1-2 Horas",
    image_url: "https://cdn.filestackcontent.com/XgKsKaVRnfpyRcBnK4Pw/convert?cache=true&compress=true&quality=90&format=webp&rotate=exif&w=920&fit=max",
    booking_link: "https://fareharbor.com/embeds/book/nautitours_pt/items/709672/?full-items=yes&flow=1580578",
    active: true,
    order: 6
  },
  {
    id: "kayak-gratis",
    translations: {
      pt: {
        title: "Kayak Grátis - Eco Experience",
        description: "Guadiana Eco Experience: Caiaque gratuito. Cuide do rio! Uma experiência única de consciência ambiental.",
        short_description: "Caiaque gratuito. Cuide do rio!"
      },
      en: {
        title: "Free Kayak - Eco Experience",
        description: "Guadiana Eco Experience: Free kayak. Take care of the river! A unique environmental awareness experience.",
        short_description: "Free kayak. Take care!"
      },
      es: {
        title: "Kayak Gratis - Eco Experience",
        description: "Guadiana Eco Experience: Kayak gratuito. ¡Cuida del río! Una experiencia única de conciencia ambiental.",
        short_description: "Kayak gratuito. ¡Cuida!"
      }
    },
    duration: "1 Hora",
    image_url: "https://cdn.filestackcontent.com/JEe2jysKTiaDH0Bmjzum/convert?cache=true&compress=true&quality=90&format=webp&rotate=exif&w=920&fit=max",
    booking_link: "https://fareharbor.com/embeds/book/nautitours_pt/items/709688/?full-items=yes&flow=1580578",
    active: true,
    order: 7
  }
];
